import LeftGroupList from "@/components/LeftGroupList";
import ButtonDialog from "@/components/ButtonDialog";
import api from "@/api";
export default {
  name: "LogicalQuestionView",
  components: {
    LeftGroupList,
    ButtonDialog
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      typeMap: {}
    };
  },
  methods: {
    deleteGroup() {
      api.deleteLogicalGroup(this.groupId).then(() => {
        this.init();
      });
    },
    deleteLogicalQuestion(qid) {
      api.deleteLogicalQuestion(qid).then(() => {
        this.fetchList();
      });
    },
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getLogicalQuestionByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getLogicalGroups().then(list => {
        this.groups = list;
        this.groupId = list[0].value;
        this.fetchList();
      });
      api.getLogicalQuestionTypeMap().then(ret => {
        this.typeMap = ret;
      });
    }
  },
  mounted() {
    this.init();
  }
};